/**
 * Town-qualified "near me" FAQs. Appended to each city page's visible FAQ list
 * AND its FAQPage JSON-LD so both stay in sync.
 */
export function nearMeFaqs(city: string) {
  return [
    {
      q: `Looking for pressure washing near me in ${city}, NY?`,
      a: `You're on the right page. Capital Pro Pressure Washing services ${city} and the surrounding Capital Region directly with our own crew and equipment — we're not a lead broker or a national franchise. Call (518) 900-1913 or request a free quote and we'll give you our next available date for ${city}.`,
    },
    {
      q: `How fast can you get to a home in ${city}?`,
      a: `We run routes through ${city} most weeks, so we can usually schedule within a few days of your call — often the same week. Quotes are free, and we confirm the exact price before any work starts.`,
    },
  ];
}

/**
 * Service-qualified "near me" FAQs for city+service landing pages
 * (e.g. "roof cleaning near me in Latham, NY").
 */
/**
 * Higher-volume search phrasing for services whose common industry name
 * differs from what homeowners actually type into Google.
 */
const SEARCH_ALIAS: Record<string, string> = {
  "roof washing": "roof cleaning",
  "black streak removal": "roof cleaning",
  "gutter cleaning": "gutter cleaning",
  "gutter guard installation": "gutter guards",
  "deck & patio cleaning": "deck cleaning",
  "deck cleaning": "deck cleaning services",
  "house washing": "house washing services",
  "exterior house cleaning": "house washing services",
  "vinyl siding cleaning": "siding cleaning",
  "concrete cleaning & sealing": "concrete cleaning",
};

export function serviceNearMeFaqs(service: string, city: string) {
  const base = service.toLowerCase();
  const s = SEARCH_ALIAS[base] ?? base;
  return [
    {
      q: `Searching for ${s} near me in ${city}, NY?`,
      a: `You've found it. Capital Pro Pressure Washing handles ${s} in ${city} and the surrounding Capital Region with our own crew and equipment — no lead brokers, no subcontractors. Call (518) 900-1913 or request a free quote for your ${city} home.`,
    },
    {
      q: `How soon can you schedule ${s} in ${city}?`,
      a: `We run routes through ${city} most weeks, so ${base} can usually be scheduled within a few days of your call — often the same week. Quotes are free and the price is confirmed before any work starts.`,
    },
  ];
}
